
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.167 17.709H5.834a.625.625 0 010-1.25h8.333a3.7 3.7 0 002.6-.823 3.559 3.559 0 00.946-2.719V7.084a3.559 3.559 0 00-.946-2.719 3.7 3.7 0 00-2.6-.823H5.834a3.7 3.7 0 00-2.6.823 3.559 3.559 0 00-.942 2.719.625.625 0 01-.625.625.625.625 0 01-.625-.625 4.738 4.738 0 011.35-3.635 4.89 4.89 0 013.442-1.157h8.333a4.89 4.89 0 013.446 1.157 4.738 4.738 0 011.346 3.635v5.833a4.738 4.738 0 01-1.346 3.635 4.89 4.89 0 01-3.446 1.157z","fill":"#8d98aa"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.995 10.725a3.134 3.134 0 01-1.952-.649L5.442 7.988a.625.625 0 01-.1-.879.625.625 0 01.879-.1l2.6 2.083a2 2 0 002.345 0l2.61-2.08a.625.625 0 01.878.1.625.625 0 01-.1.878l-2.606 2.082a3.135 3.135 0 01-1.953.653zM6.667 14.375h-5a.625.625 0 01-.625-.625.625.625 0 01.625-.625h5a.625.625 0 01.625.625.625.625 0 01-.625.625zM4.167 11.042h-2.5a.625.625 0 01-.625-.625.625.625 0 01.625-.625h2.5a.625.625 0 01.625.625.625.625 0 01-.625.625z","fill":"#8d98aa","opacity":".4"}})])
          )
        }
      }
    